import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6982fa4f921dc900146f1bcc/egregorsite/src/app/cookie-policy/page.tsx");
